var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001246",
    d: "M9.474 4.632c.258 0 .473.178.518.412l.008.09v4.363c0 .247-.186.452-.432.495L9.474 10H.526c-.258 0-.473-.178-.518-.412L0 9.498V5.134c0-.278.236-.503.526-.503.259 0 .474.178.518.412l.009.09v3.86h7.894v-3.86c0-.277.236-.502.527-.502zM5.429.172l2.164 2.432c.182.204.158.51-.054.681-.212.172-.532.145-.715-.06L5.56 1.805 5.6 7.22c.001.267-.224.483-.504.481-.28-.002-.508-.22-.51-.487L4.546 1.8 3.298 3.205c-.18.203-.5.226-.714.052-.214-.174-.242-.48-.062-.682L4.656.17c.201-.227.57-.225.773.004z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bc7a2df3a2c9b7ae693d41f917fd9732.svg";
export { ForwardRef as ReactComponent };